import {createSlice} from '@reduxjs/toolkit';
import {DefaultSlice} from './DefaultSlice';

const type = 'bodySections';
const slice = new DefaultSlice(type);
slice.assignThunkNames(type);
const sliceName = 'BodySectionsSlice';
const thunks = slice.getThunks(sliceName);

const BodySectionsThunks = thunks.reduce((acc, current, index) => {
  const thunkName = slice.thunkNames[index];
  return {...acc, [thunkName]: current.create};
}, {});

export const BodySectionsSlice = createSlice({
  name: sliceName,
  initialState: slice.initialState,
  extraReducers(builder) {
    slice.extraReducers(slice.asyncThunks, builder);
  },
});

// Action creators are generated for each case reducer function
export const BodySectionsActions = BodySectionsSlice.actions;
export {BodySectionsThunks};

export default BodySectionsSlice.reducer;
